import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { updateTrial } from '../slice';

function* saveTrial({ payload: { action, params, onSuccess } }) {
  const { success, data, error } = yield* makeRequest.action(action, params);
  if (success && data) {
    if (onSuccess) {
      onSuccess({ data });
    }
    yield put(updateTrial(data.unwrap()));
  } else if (error) {
    yield* putErrorActions({ error });
  }
  return null;
}

export default saveTrial;
